import {Component, OnInit} from '@angular/core';
import {AuthorisedSideNavService} from '../services/authorised-side-nav.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-authorised-side-nav',
    templateUrl: './authorised-side-nav.component.html',
    styleUrls: ['./authorised-side-nav.component.css']
})
export class AuthorisedSideNavComponent implements OnInit {
    constructor(public sideNavService: AuthorisedSideNavService, private router: Router) {
    }

    ngOnInit() {
    }

    returnUrl() {
        return this.router.url;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-side-nav/authorised-side-nav.component.ts